/// <amd-module name="VSSUI/Components/IdentityPickerSuggestionsList/IdentityPickerSuggestionItem" />
import * as React from "react";
import { Button } from "VSSUI/Button";
import { Icon } from "VSSUI/Icon";
import { Persona, PersonaSize } from "VSSUI/Persona";
import * as Resources from "VSSUI/Resources.IdentityPicker";
import { Tooltip } from "VSSUI/TooltipEx";
import { IFocusable } from "VSSUI/Utilities/Focus";
import { getScopedGroupParts, getSignInAddress, isGithubUser, shouldShowIdentityCard } from "../IdentityPickerDropdown/IdentityPickerUtils";
import { IdentityType } from "../IdentityPickerDropdown/SharedIdentityPicker.Props";
import { IIdentitySuggestionItemProps } from "./IdentityPickerSuggestionsList.Props";

export class IdentityPickerSuggestionItem extends React.Component<IIdentitySuggestionItemProps> implements IFocusable<{}> {
    private contactCardButtonRef = React.createRef<Button>();

    public render() {
        const identity = this.props.item;
        let signInAddress = getSignInAddress(identity);
        let displayName = identity.displayName;

        const scopedGroupParts = getScopedGroupParts(identity);
        if (scopedGroupParts) {
            displayName = scopedGroupParts.name;
            if (!signInAddress) {
                signInAddress = scopedGroupParts.scope;
            }
        }

        return (
            <div className="bolt-picker-suggesteditem flex-row flex-grow flex-center scroll-hidden">
                {this.props.renderSuggestion && identity.entityType === IdentityType.Custom ? (
                    this.props.renderSuggestion(this.props)
                ) : (
                    <div className="bolt-picker-suggesteditem-text flex-row flex-grow flex-center text-ellipsis">
                        <Persona ariaHidden={true} className="bolt-picker-persona text-ellipsis" identity={identity} size={PersonaSize.size24} />

                        <div className="bolt-picker-persona-name flex-column flex-grow">
                            {displayName && (
                                <Tooltip text={identity.displayName} overflowOnly={identity.displayName === displayName}>
                                    <div className="fontSizeM text-ellipsis">{displayName}</div>
                                </Tooltip>
                            )}
                            {!signInAddress ? (
                                undefined
                            ) : (
                                <div className="flex-row">
                                    {isGithubUser(identity) && (
                                        <Icon className="bolt-identitypicker-github-icon flex-row flex-center justify-center" iconName="GitHubLogo" />
                                    )}
                                    <div className="fontSize secondary-text text-ellipsis">{signInAddress}</div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                {!!this.props.onOpenPersonaCard && shouldShowIdentityCard(identity) && (
                    <Button
                        ariaLabel={Resources.IdentityPickerProfileCardButtonTooltip}
                        className="bolt-contact-card-button flex-noshrink"
                        iconProps={{ iconName: "ContactCard", className: "flex-shrink" }}
                        onClick={(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
                            this.props.onOpenPersonaCard && this.props.onOpenPersonaCard(identity);
                            e.preventDefault();
                        }}
                        onBlur={this.props.onBlur}
                        onFocus={this.props.onFocus}
                        ref={this.contactCardButtonRef}
                        subtle={true}
                        tooltipProps={{ text: Resources.IdentityPickerProfileCardButtonTooltip, showOnFocus: true }}
                    />
                )}
            </div>
        );
    }

    public focus() {
        if (this.contactCardButtonRef.current) {
            this.contactCardButtonRef.current.focus();
        }
    }
}
